import { Observable } from 'rxjs';
import { Cliente, CreateClienteDto, UpdateClienteDto } from '../../models/clienti.model';
import {AttoriQueryParams, AttoriPagedResponse, CreateAttoreDto} from '../../models/attori.model';

export abstract class ClientiPort {
  abstract getList(): Observable<Cliente[]>;
  abstract getListPaginated(params: AttoriQueryParams): Observable<AttoriPagedResponse<Cliente>>;
  abstract getById(id: number): Observable<Cliente>;
  abstract create(dto: CreateClienteDto): Observable<Cliente>;
  abstract update(id: number, changes: UpdateClienteDto): Observable<Cliente>;
  abstract delete(id: number): Observable<void>;
  abstract updateAttore(id: number, dto: Partial<CreateAttoreDto>): Observable<void>;
  // ATTORI
  abstract updateAttore(id: number, dto: Partial<CreateAttoreDto>): Observable<void>;

  // RECAPITI
  abstract createRecapito( dto: any): Observable<void>;
  abstract updateRecapito(id: number, dto: any): Observable<void>;
  abstract deleteRecapito(id: number): Observable<void>;

  // CONTI BANCARI
  abstract createConto(idAttore: number, dto: any): Observable<void>;
  abstract updateConto(id: number, dto: any): Observable<void>;
  abstract deleteConto(id: number): Observable<void>;
}
